export default __webpack_public_path__ + "static/media/point.53eb43ad.svg";